import React, { useMemo, useRef } from "react";
import { useWindowVirtualizer } from "@tanstack/react-virtual";

export const useVirtualizedRows = ({ usersMap, searchValue, estimateSize = 40 }) => {
  const listRef = useRef(null);

  const virtualizedRows = useMemo(() => {
    const rows = [];
    if (!usersMap) return rows;

    Object.entries(usersMap).forEach(([orgName, userList]) => {
      if (userList.length > 0) {
        rows.push({ type: "header", orgName });
        userList.forEach((user) => {
          rows.push({ type: "user", orgName, user });
        });
      }
    });

    return rows;
  }, [usersMap, searchValue]);

  const rowVirtualizer = useWindowVirtualizer({
    count: virtualizedRows.length,
    estimateSize: () => estimateSize,
    scrollMargin: listRef.current?.offsetTop ?? 0
  });

  return {
    listRef,
    virtualizedRows,
    rowVirtualizer,
    virtualItems: rowVirtualizer.getVirtualItems()
  };
};
